import { invoiceFinancingCriteria, invoiceFinancingFees } from './invoiceFinancing';
import { tradeFinanceCriteria, tradeFinanceFees } from './tradeFinance';
import { merchantCashAdvanceCriteria, merchantCashAdvanceFees } from './merchantCashAdvance';
import { assetBackedFinanceCriteria, assetBackedFinanceFees } from './assetBackedFinance';
import { termLoansCriteria, termLoansFees } from './termLoans';
import { commercialPropertyCriteria, commercialPropertyFees } from './commercialProperty';
import { requestHelp } from './requestHelp';

const uiSchema = Object.freeze({
  invoiceFinancingCriteria,
  invoiceFinancingFees,
  tradeFinanceCriteria,
  tradeFinanceFees,
  merchantCashAdvanceCriteria,
  merchantCashAdvanceFees,
  assetBackedFinanceCriteria,
  assetBackedFinanceFees,
  termLoansCriteria,
  termLoansFees,
  commercialPropertyCriteria,
  commercialPropertyFees,
  requestHelp,
});

export const getUiSchema = (key) => uiSchema[key];
